// extracted by mini-css-extract-plugin
module.exports = {"report--body":"report--body__2B_Qs"};